/**
 * @generated SignedSource<<557272af71598ff576ed00506a21dc3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetKPI_widgetKPI$data = {
  readonly dataSource: string;
  readonly id: string;
  readonly tiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Tile_kpiTile">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetKPI_widgetKPI";
};
export type WidgetKPI_widgetKPI$key = {
  readonly " $data"?: WidgetKPI_widgetKPI$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetKPI_widgetKPI">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetKPI_widgetKPI",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataSource",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetKPITile",
      "kind": "LinkedField",
      "name": "tiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Tile_kpiTile"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetKPI",
  "abstractKey": null
};

(node as any).hash = "1e7c7197989f1d497896b087ba7d0049";

export default node;
